import React from "react";
import ReactApexChart from "react-apexcharts";

const CompletionRateLineChart = ({
  series = [],      
  categories = [], 
  colors = ["#363062", "#1EA7C5", "#FF9432"],
  height = 350,
  title = "معدل إتمام الطلاب للبرامج في الحد الأدنى من المدة",
}) => {
  const options = {
    chart: {
      height: height,
      type: "line",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: Array(series.length).fill(4),
      colors: colors.slice(0, series.length),
      curve: "straight",
    },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "right",
      labels: {
        style: {
          fontFamily: "Cairo",
        },
      },
    },
    xaxis: {
      type: "category",
      categories: categories,
      labels: {
        style: {
          fontFamily: "Cairo",
        },
      },
    },
    colors: colors.slice(0, series.length),
    markers: {
      size: Array(series.length).fill(6),
      strokeWidth: 2,
      strokeColors: colors.slice(0, series.length),
      colors: ["#fff"],
      hover: {
        size: 8,
      },
    },
    yaxis: {
      title: {
        // text: "نسبة الإتمام %",
        style: {
          fontFamily: "Cairo",
        },
      },
      labels: {
        formatter: (val) => `${val}%`,
        style: {
          fontFamily: "Cairo",
        },
      },
      min: 0,
      max: 100,
    },
    tooltip: {
      y: {
        formatter: (val) => `${val.toFixed(2)}%`,
      },
    },
  };

  return (
    <div className="card mt-4 p-3">
      <h5 className="mb-3" style={{ fontFamily: "Cairo" }}>{title}</h5>
      <ReactApexChart options={options} series={series} type="line" height={height} />
    </div>
  );
};

export default CompletionRateLineChart;
